const NotFound = () => {
    return ( 

        <div className="text-center" style={{height: "100%"}}>
            <hr />
            <br />

            <h1>404 - PageNotFound</h1>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
  <br />

        </div>
     );
}
 
export default NotFound;